
import React from "react";

import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { getApiData } from "../utils/index";

const Lookup = (props) => {
    const [useDefaultSearch, setUseDefaultSearch] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [list, setList] = React.useState([]);
    const [inputValue, setInputValue] = React.useState("");
    const latestRequestRef = React.useRef(0);
    const typeaheadRef = React.useRef(null);

    React.useEffect(() => {
        setInputValue("");
        
        if(props.selected && props.selected.length == 0) {
            setList([]);

            if (typeaheadRef.current) {
                typeaheadRef.current.clear();
            }
        }
        
        if(useDefaultSearch && props.defaultSearch) {
		    doSearch("", props.defaultSearch);
        }
    }, [props.defaultSearch, props.url, props.id]);

    const doSearch = async (search, id = null) => {
        const requestId = ++latestRequestRef.current;

        setLoading(true);
        setUseDefaultSearch(false);

        try {

            var data = await getApiData("Lookup/" + props.url, {search, id});

            if (requestId !== latestRequestRef.current) {
                return;
            }
            
            if(data.success) {
                setList(data.responseEntities[0].dataList || []);
            }
            else {
                setList([]);
                alert(data.errorDesc);
            }
        } 
        catch (error) {
            if (requestId !== latestRequestRef.current) {
                return;
            }

            alert(error);
            setList([]);
        }
        finally {
            if (requestId === latestRequestRef.current) {
                setLoading(false);
            }
        }
    };

    const onInputChange = (value) => {
        setInputValue(value);
        setList([]);

        if (value && value.length >= 1) {
            doSearch(value);
        }
        else {
            setList([]);
        }
    };

    return (
        <AsyncTypeahead
            {...props}
            className="custom-lookup"
            ref={typeaheadRef}
            useCache={false}
            filterBy={() => true}
            isLoading={loading}
            minLength={1}
            //onSearch={doSearch}
            //onInputChange={(value) => doSearch(value, null)}
            onSearch={() => console.log("nothing")}
            onInputChange={onInputChange}
            options={list}
        />
    );
};

export default Lookup;